import { jsx as t, jsxs as h } from "react/jsx-runtime";
import { useRef as q } from "react";
import { CommentContent as z } from "../CommentContent/index.js";
import { CommentViewContainer as D, CommentBadgeOnView as E, CommentActionsWithReactionsOnView as G, CommentActionsOnView as H } from "./style.js";
import { PrivateComment as J } from "../../PrivateComment/index.js";
import { useScrollToComment as K } from "../../hooks/useScrollToComment.js";
function _({
  id: o,
  content: e,
  timestamp: V,
  className: y,
  profileURL: O,
  author: n,
  authorImage: r,
  isAuthorVerified: x,
  liked: R,
  count: j,
  reacted: u,
  reactions: A,
  badge: i,
  moreOptions: k,
  isModerated: f,
  isPending: c,
  isDeleted: v,
  isEdited: B,
  isFocused: m,
  isNewComment: L,
  areReactionsEnabled: N,
  parentComment: C,
  clickoutFunction: p,
  dispatch: s,
  goToProfile: a,
  disableReply: S = !1
}) {
  const l = q(null), w = f || c, W = w ? 0.6 : 1;
  return K({ commentRef: l, isFocused: m }), w ? /* @__PURE__ */ t(
    J,
    {
      content: e || "",
      image: r || "",
      authorNickname: n || "",
      parentComment: C,
      isModerated: f,
      isPending: c,
      isFocused: m,
      clickoutFunction: p,
      goToProfile: a
    }
  ) : /* @__PURE__ */ h(
    D,
    {
      ref: l,
      className: y,
      "data-focused": m,
      style: {
        "--container-opacity": W
      },
      children: [
        i && /* @__PURE__ */ t(E, { type: i }),
        /* @__PURE__ */ t(
          z,
          {
            authorImage: r,
            author: n,
            goToProfile: a,
            clickoutFunction: p,
            content: e,
            timestamp: V,
            moreOptions: k,
            isEdited: B,
            isDeleted: v,
            parentComment: C,
            isNewComment: L,
            isAuthorVerified: x,
            profileURL: O
          }
        ),
        N ? /* @__PURE__ */ t(
          G,
          {
            id: o || "",
            dispatch: s,
            reacted: u,
            reactions: A,
            disableReply: S
          }
        ) : /* @__PURE__ */ t(
          H,
          {
            id: o || "",
            count: j,
            liked: R,
            dispatch: s
          }
        )
      ]
    }
  );
}
export {
  _ as CommentView
};
